export default {
    "Imperial": {
        fieldName: "Imperial",
        symbol: "°F"
    },
    "Metric": {
        fieldName: "Metric",
        symbol: "°C"
    }
}